import { fetchApi } from 'react-scale/redux/actions';
import { ExecuteSubmissionResponse } from '@scale/shared/sphereEngine/types';
import { CodeBlock } from 'react-scale/components/scalers/tasks/ThreadedInteraction/coding/types';
import { SphereSubmissionEvent } from '@scale/shared/types/events/SphereSubmission';
import { Event, logEvent } from 'react-scale/lib/events';
import { ICustomCodeEnvironment } from '@scale/shared/types/config';

export const ASSIGNMENT_DETAILS_FETCH_REFRESH_TIME = 1000 * 60 * 60 * 3; // 3 hours

export const executeCodeSubmission = async (
  code: string,
  language: string,
  logData?: SphereSubmissionEvent,
  assignmentId?: string,
  customCodeEnvironment?: ICustomCodeEnvironment | null,
): Promise<ExecuteSubmissionResponse | undefined> => {
  let submissionResponse;
  let successfulExecution;
  try {
    submissionResponse = await fetchApi<ExecuteSubmissionResponse>(`/genai/executeSubmission`, {
      body: {
        sourceCode: code,
        language,
        customEnvConfig: customCodeEnvironment
          ? {
              projectId: customCodeEnvironment.sphereEngineProjectId,
              scenarioName: customCodeEnvironment.scenario,
              entryPoint: customCodeEnvironment.entryPoint,
              customEnvName: customCodeEnvironment.name,
              useCustomFiles: !!customCodeEnvironment.customFiles,
            }
          : undefined,
        assignmentId,
      },
      maxRetries: 3,
      method: 'POST',
      parseAndHandle: true,
      redirectOnUnauthorized: true,
    });
    successfulExecution = submissionResponse?.success;
  } catch (e) {
    successfulExecution = false;
    throw e;
  } finally {
    if (logData) {
      await logEvent(Event.SphereSubmissionEvent, {
        ...logData,
        successfulExecution,
      });
    }
  }
  return submissionResponse;
};

export const extractCodeBlocks = (markdownText: string): CodeBlock[] => {
  const codeBlocks: CodeBlock[] = [];
  const codeBlockRegex = /```(\w*)\s*(?:\r?\n)((?:.|[\r\n])*?)(?:\r?\n)```/g;
  let match: RegExpExecArray | null;

  while ((match = codeBlockRegex.exec(markdownText)) !== null) {
    const [, language, code] = match;
    codeBlocks.push({ language, code });
  }

  return codeBlocks;
};
